import { generateTemplate } from 'utils/helpers';
import {
  rowMenuCells,
  STATUS_COLUMN,
} from 'components/stock-ltl-row-menu/config';

export const titles = [
  'Date',
  'From',
  'To',
  'Wholesale Cost',
  'LTL Price',
  'LTL Invoice #',
  'Status',
  'Created By',
  // T-F07: the row menu ("⋯")
  '',
];

// Date … LTL Invoice # equal, Status (full label), Created By, row menu
const STATUS_INDEX = titles.indexOf('Status');
export const template = [
  generateTemplate(STATUS_INDEX),
  STATUS_COLUMN,
  generateTemplate(titles.length - STATUS_INDEX - 2),
  '24px',
].join(' ');
export const cellsTablet = rowMenuCells(titles.length);
